__webpack_require__.p = "/portfolio_sithara/";